import { z } from 'zod'

export const recommendEventSchema = z.object({
  type: z.enum(['rec_impression', 'rec_click', 'rec_add_to_cart']),
  product_id: z.coerce.number().int().positive(),
  placement: z.string().regex(/^[a-z0-9:_-]{1,64}$/),
  rank: z.number().int().positive(),
})

export const recommendEventsSchema = z.object({
  events: z.array(recommendEventSchema).min(1).max(50),
})

export type RecommendEventType = z.infer<typeof recommendEventSchema>['type']
export type RecommendEvent = z.infer<typeof recommendEventSchema>
